module.exports = __webpack_public_path__ + "assets/img/22.b3110a41.png";